import clsx from 'clsx';

import {Badge} from './Badge';

import type {Tag} from '../../types';

type Props = Omit<React.ComponentProps<typeof Badge>, 'colour'> & {
  tag: Tag;
};
export function TagBadge({
  tag,
  className,
  ...restProps
}: Props): React.JSX.Element {
  const cn = clsx(className, tag.isArchived && 'line-through');

  return <Badge {...restProps} className={cn} colour="slate" />;
}

TagBadge.displayName = 'TagBadge';
